import React from 'react';
import Layout from '../../components/Layout/Layout';
import { useState } from 'react';
import RoleServices from '../../services/RoleServices';
import { useEffect } from 'react';
import UserServices from '../../services/UserServices';
import fire from './../../utils/Toastr';
import { HollowDotsSpinner } from 'react-epic-spinners';

export default function CreateUser() {
    const user = {
        roleId: 0, 
        userName: "",
        firstName: "",
        branchName: "",
        region: "",
        lastName: "",
        email: "", 
        adminType:""             
    }
    const errors = {
        userNameIsValidated: "",
        userError: "",
        emailIsValiadted: "",
        emailError: "",
        firstNameIsValidated: "",
        firstNameError: "",
        lastNameIsValidated: "",
        lastNameError: "",
        departmentError: "",
        departmentHandler: "",
        branchNameError: "",
        branchNameIsValidated: "",
        formIsSubmitting: false
    }
    const [formValues, setFormValues] = useState(user);
    const [formState, setFormState] = useState(errors);
    const [role, setRole] = useState([]);
    const [loading, setLoading] = useState(false)

    const roles = async () => {
        const listRoles = await RoleServices.listRoles(1, 10,"");
        setRole([...listRoles.data.result]);
    }
    const formValidation = {
        userNameHandler: (event) => {
            setFormValues({ ...formValues, userName: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    userError: "Username cannot be empty",
                    userNameIsValidated: false
                });
                return;
            }
            if (/^[1-9][0-9]*$/.test(event.target.value)) {
                setFormState({
                    ...formState,
                    userError: "Enter a valid username",
                    userNameIsValidated: false,
                });
                return;
            }
            setFormState({
                ...formState,
                userError: "",
                userNameIsValidated: true,
            });
        },
        firstNameHandler: (event) => {
            setFormValues({ ...formValues, firstName: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    firstNameError: "First name cannot be empty",
                    firstNameIsValidated: false
                });
                return;
            }
            if (/^[1-9][0-9]*$/.test(event.target.value)) {
                setFormState({
                    ...formState,
                    firstNameError: "Enter a valid name",
                    firstNameIsValidated: false,
                });
                return;
            }
            setFormState({
                ...formState,
                firstNameError: "",
                firstNameIsValidated: true,
            });
        },
        lastNameHandler: (event) => {
            setFormValues({ ...formValues, lastName: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    lastNameError: "Last name cannot be empty",
                    lastNameIsValidated: false
                });
                return;
            }
            if (/^[1-9][0-9]*$/.test(event.target.value)) {
                setFormState({
                    ...formState,
                    lastNameError: "Enter a valid name",
                    lastNameIsValidated: false,
                });
                return;
            }
            setFormState({
                ...formState,
                lastNameError: "",
                lastNameIsValidated: true,
            });
        },
        branchNameHandler: (event) => {
            setFormValues({ ...formValues, branchName: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    branchNameError: "Branch name required",
                    branchNameIsValidated: false
                });
                return;
            }
            if (/^[1-9][0-9]*$/.test(event.target.value)) {
                setFormState({
                    ...formState,
                    branchNameError: "Enter a valid name",
                    branchNameIsValidated: false,
                });
                return;
            }
            setFormState({
                ...formState,
                branchNameError: "",
                branchNameIsValidated: true,
            });
        },
        regionHandler: (event) => {
            setFormValues({ ...formValues, region: event.target.value });
        },
        roleHandler: (event) => {
            setFormValues({ ...formValues, roleId: event.target.value });
        },
        adminHandler:(event) => {
            setFormValues({...formValues,adminType:event.target.value})
        },
        departmentHandler: (event) => {
            setFormValues({ ...formValues, department: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    departmentError: "Department required",
                    departmentIsValidated: false
                });
                return;
            }
            if (/^[1-9][0-9]*$/.test(event.target.value)) {
                setFormState({
                    ...formState,
                    departmentError: "Enter a valid name",
                    departmentIsValidated: false,
                });
                return;
            }
            setFormState({
                ...formState,
                departmentError: "",
                departmentIsValidated: true,
            });
        },
        emailHandler: (event) => {
            setFormValues({ ...formValues, email: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    emailError: "Field cannot be empty",
                    emailIsValiadted: false
                });
                return;
            }
            if (/^w+[+.w-]*@([w-]+.)*w+[w-]*.([a-z]{2,4}|d+)$/i.test(event.target.value)) {
                setFormState({
                    ...formState,
                    emailError: "Invalid email address",
                    emailIsValiadted: false,
                });
                return;
            }
            setFormState({
                ...formState,
                emailError: "",
                emailIsValiadted: true
            });
        }
    }
    const submitForm = async (e) => {
        setLoading(true);
        e.preventDefault();
        const isFilledCorrectly =
        formState.userNameIsValidated && formState.emailIsValiadted;
      setFormState({ ...formState, formIsSubmitting: true });
      if(!isFilledCorrectly){
       fire("error", "Field is required");
       setLoading(false);
       return;
      }
      const user = await UserServices.createUser(formValues);
      if (user) {
        fire("success", user.message)
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        setLoading(false);
         
      }
    
      
    }
    useEffect(() => {
        roles();
    },[])
    return (
        <>
            <Layout title="Create User" pageTag={'admin'} current={'/create/user'}>
                <React.Fragment>
                    <main>
                        <div className='max-w-7xl mx-auto'>
                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                <div className=''>
                                                    <div className='inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                        {/* form */}
                                                        <form className='px-6' onSubmit={submitForm}>
                                                            <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                                <div className="sm:col-span-3">
                                                                    <label htmlFor="firstname" className="block text-sm font-medium text-gray-700">
                                                                        First name
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input
                                                                            type="text"
                                                                            name="firstname"
                                                                            onChange={formValidation.firstNameHandler}
                                                                            value={formValues.firstName}
                                                                            id="firstnmae"
                                                                            autoComplete="given-name"
                                                                            placeholder="Enter user's first name"
                                                                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        <p className='text-sm text-rose-800'>{formState.firstNameError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-3">
                                                                    <label htmlFor="surname" className="block text-sm font-medium text-gray-700">
                                                                        Last name
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input
                                                                            type="text"
                                                                            name="surname"
                                                                            id="surname"
                                                                            placeholder="Enter user's last name"
                                                                            onChange={formValidation.lastNameHandler}
                                                                            value={formValues.lastName}
                                                                            autoComplete="given-name"
                                                                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        <p className='text-sm text-rose-800'>{formState.lastNameError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                                                                        Username
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text"
                                                                            name="username"
                                                                            id="username"
                                                                            placeholder="Enter user's username"
                                                                            onChange={formValidation.userNameHandler}
                                                                            value={formValues.userName}
                                                                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        <p className='text-sm text-rose-800'>{formState.userError}</p>
                                                                    </div>
                                                                </div>
                                                                                                                            

                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                                                        Email
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input
                                                                            type="email"
                                                                            onChange={formValidation.emailHandler}
                                                                            value={formValues.email}
                                                                            name="email"
                                                                            placeholder="Enter user's email address"
                                                                            id="email"
                                                                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        <p className='text-sm text-rose-800'>{formState.emailError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                        Region
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input
                                                                            type="text"
                                                                            value={formValues.region}
                                                                            onChange={formValidation.regionHandler}
                                                                            name="region"
                                                                            placeholder="Enter user's region"
                                                                            id="region"
                                                                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />

                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700">
                                                                        Role
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <select
                                                                            placeholder='Select role'
                                                                            id="role"
                                                                            name="role"
                                                                             onChange={formValidation.roleHandler}
                                                                             value={formValues.roleId}
                                                                             className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                        >

                                                                            <option value="">Select role</option>
                                                                            {role.map((item, i) =>
                                                                                <option key={i} value={item.id}>{item.roleName}</option>
                                                                            )}

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700">
                                                                        Admin Type
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <select
                                                                            placeholder='Select role'
                                                                            id="role"
                                                                            name="role"
                                                                            onChange={formValidation.adminHandler}
                                                                            value={formValues.adminType}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                            defaultValue="Select role"
                                                                        >

                                                                            <option value="">Select admin type</option>
                                                                           <option value="Maker">Maker</option>
                                                                           <option value="Checker">Checker</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='mt-4 flex justify-end'>
                                                                <button
                                                                    onClick={() => window.location.reload(true)}
                                                                    type='submit'
                                                                    className='btn-sec hover:text-white focus:text-white mr-2 bg-gray-100 text-gray-900 inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium  shadow-sm  sm:w-auto'>
                                                                    Reset
                                                                </button>
                                                                {loading === false ? 
                                                                <button type='button' 
                                                                onClick={submitForm} 
                                                                className='btn-primary text-white inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto'>
                                                                    Save User
                                                                </button> : <HollowDotsSpinner size={20} color="#4D627E" />
}
                                                            </div>
                                                        </form>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </main>
                </React.Fragment>

            </Layout>


        </>
    );
}